interface LanguageOption {
  code: string
  name: string
  englishName: string
  dateInputFormat?: string
}

const LANGUAGE_OPTIONS: LanguageOption[] = [
  {
    code: 'sr-latn',
    name: 'Srpski (latinica)',
    englishName: 'Serbian (Latin)',
    dateInputFormat: 'dd.mm.yyyy',
  },
  {
    code: 'en-us',
    name: 'English',
    englishName: 'English',
    dateInputFormat: 'mm/dd/yyyy',
  },
]

const ISO_LANGUAGE_OPTION: LanguageOption = {
  code: 'iso-8601',
  name: 'ISO 8601',
  englishName: 'ISO 8601',
  dateInputFormat: 'yyyy-mm-dd',
}

const SYSTEM_LANGUAGE_OPTION: LanguageOption = {
  code: '',
  name: 'Koristi sistemski jezik',
  englishName: 'Use system language',
}

export const DATE_LOCALE_OPTIONS: LanguageOption[] = [SYSTEM_LANGUAGE_OPTION, ...LANGUAGE_OPTIONS, ISO_LANGUAGE_OPTION]

export const DISPLAY_LANGUAGE_OPTIONS: LanguageOption[] = [SYSTEM_LANGUAGE_OPTION, ...LANGUAGE_OPTIONS]

export function mapBackendToI18nCode(backendCode?: string | null): string {
  if (!backendCode) return 'sr'
  const normalized = backendCode.toLowerCase()
  if (normalized.startsWith('sr')) return 'sr'
  if (normalized.startsWith('en')) return 'en'
  return 'sr'
}

export function mapI18nToBackendCode(i18nCode?: string | null): string {
  if (!i18nCode) return 'sr-cs'
  const normalized = i18nCode.toLowerCase()
  if (normalized === 'en' || normalized.startsWith('en-')) {
    return 'en-us'
  }
  return 'sr-cs'
}

export { LANGUAGE_OPTIONS }
